import React, { useEffect, useState, useRef } from 'react';
import './LiveCut.scss';
import { IComponentLiveCut } from '../../component';
import useTheme from '../hooks/useTheme';
import classNames from 'classnames';
import { inject, observer } from 'mobx-react';
import { IMedium } from '../../store/VideoStore';
import RootStore from '../../store/RootStore';
import { style } from '../../utils/image';
import ReactSVG from 'react-svg';
import intl from 'react-intl-universal';
import { formatDuration } from '../../utils/video';
// @ts-ignore
import Masonry from 'react-responsive-masonry';

interface ILiveCut extends IComponentLiveCut {
  rootStore?: RootStore;
  onPlayVideo: (item: IMedium, index: number) => void;
  inSearch?: string;
  currentIndex: number;
  cid: string;
}

const getMediumOptions = (item: IMedium) => {
  try {
    return typeof item.options === 'string'
      ? JSON.parse(item.options)
      : item.options || {};
  } catch (e) {
    return {};
  }
};

const isPortraitVideo = (item: IMedium) => {
  const options = getMediumOptions(item);
  const width = Number(options.width);
  const height = Number(options.height);

  // 老数据可能没有视频尺寸；仅在尺寸明确有效时启用新布局。
  return width > 0 && height > 0 && height > width;
};

const Index = (props: ILiveCut) => {
  const { inSearch, rootStore, mode, onPlayVideo, currentIndex, cid} = props;
  const { videoStore } = rootStore!;
  const { h1Color, h2Color, mainColor } = useTheme();

  let livecut_search = videoStore.livecut_search[cid] || {
    items:[],
    total:-1
  };
  let livecut_list = videoStore.livecut_list[cid] || {
    items:[],
    total:-1
  };

  let list = !!inSearch ? livecut_search.items : livecut_list.items;
  let total = !!inSearch ? livecut_search.total : livecut_list.total;

  const [portraitCoverMap, setPortraitCoverMap] = useState<Record<string, boolean>>({});

  const getCoverKey = (item: IMedium) => `${item.id}_${item.thumb || ''}`;

  const isPortraitItem = (item: IMedium) => {
    // 上传封面优先按图片加载后的真实尺寸判断；未知或加载失败时保持旧横版布局。
    if (item.thumb) {
      return portraitCoverMap[getCoverKey(item)] === true;
    }

    // 没有上传封面、使用视频截图时，才按视频元数据判断方向。
    return isPortraitVideo(item);
  };

  const onCoverLoaded = (
    item: IMedium,
    event: React.SyntheticEvent<HTMLImageElement>
  ) => {
    if (!item.thumb) {
      return;
    }

    const image = event.currentTarget;
    const width = Number(image.naturalWidth);
    const height = Number(image.naturalHeight);
    if (!(width > 0 && height > 0)) {
      return;
    }

    const key = getCoverKey(item);
    const isPortrait = height > width;
    setPortraitCoverMap(current => {
      if (current[key] === isPortrait) {
        return current;
      }
      return {
        ...current,
        [key]: isPortrait
      };
    });
  };

  const renderMode3 = (it: IMedium, index: number) => {
    const options = getMediumOptions(it);

    return (
      <div
        key={it.id}
        id={`livecut_${index}`}
        className={classNames('livecut-item', 'type-3', {
          'is-portrait': isPortraitItem(it)
        })}
        onClick={() => {
          onPlayVideo && onPlayVideo(it, index);
        }}
      >
        <div className="wrapper">
          <div className="thumb">
            <img
              src={it.thumb ? style(it.thumb, 'wx_375_240') : `${it.source}?x-oss-process=video/snapshot,t_3000,f_jpg,w_750,m_fast`}
              onLoad={event => onCoverLoaded(it, event)}
            />
            <div className="ico-play">
              <ReactSVG src={require('../../svg/video-play.svg')} />
            </div>
            {options && options.duration ? <div className="duration">{formatDuration(options.duration, 'seconds')}</div> : null}
          </div>
          <div className="info">
            <div className="title" style={{color:h1Color}}>{it.desc}</div>
            {options.remark ? <div className="remark" style={{color:h2Color}}>{options.remark}</div> : null}
          </div>
        </div>
      </div>
    );
  };

  const renderMode2 = (it: IMedium, index: number) => {
    const options = getMediumOptions(it);

    return (
      <div
        key={it.id}
        id={`livecut_${index}`}
        className={classNames('livecut-item', 'type-2', {
          'is-portrait': isPortraitItem(it)
        })}
        onClick={() => {
          onPlayVideo && onPlayVideo(it, index);
        }}
      >
        <div className="wrapper">
          <div className="thumb">
            <img
              src={it.thumb ? style(it.thumb, 'wx_375_240') : `${it.source}?x-oss-process=video/snapshot,t_3000,f_jpg,w_750,m_fast`}
              onLoad={event => onCoverLoaded(it, event)}
            />
            <div className="ico-play">
              <ReactSVG src={require('../../svg/video-play.svg')} />
            </div>
            {options && options.duration ? <div className="duration">{formatDuration(options.duration, 'seconds')}</div> : null}
          </div>
          <div className="info">
            <div className="title" style={{color:h1Color}}>{it.desc}</div>
            {options.remark ? <div className="remark" style={{color:h2Color}}>{options.remark}</div> : null}
          </div>
        </div>
      </div>
    );
  };

  const renderMode1 = (it:IMedium, index:number)=>{
    const options = getMediumOptions(it);

    return (
      <div
        key={it.id}
        id={`livecut_${index}`}
        className={classNames('livecut-item', 'type-1', {
          'is-portrait': isPortraitItem(it)
        })}
        onClick={() => {
          onPlayVideo && onPlayVideo(it, index);
        }}
      >
        <div className="wrapper">
          <div className="thumb">
            <img
              src={it.thumb ? style(it.thumb, 'wx_375_240') : `${it.source}?x-oss-process=video/snapshot,t_3000,f_jpg,w_750,m_fast`}
              onLoad={event => onCoverLoaded(it, event)}
            />
            <div className="ico-play">
              <ReactSVG src={require('../../svg/video-play.svg')} />
            </div>
            {options && options.duration ? <div className="duration">{formatDuration(options.duration, 'seconds')}</div> : null}
          </div>
          <div className="info">
            <div className="title" style={{color:h1Color}}>{it.desc}</div>
          </div>
        </div>
      </div>
    );
  };

  const renderItem = (it: IMedium, index: number) => {
    if (currentIndex >= 0) {
      return (
        <div className="liveshow-item" key={it.id}>
          <div className="wrapper">
            <div style={{ paddingBottom: mode == 'h' ? '56%' : '177%' }} />
          </div>
        </div>
      );
    }
    if(mode == '3') {
      return renderMode3(it, index);
    }
    if (mode == '2') {
      return renderMode2(it, index);
    }
    if (mode == '1') {
      return renderMode1(it, index);
    }
  };

  const renderEmpty = () => {
    if (typeof total != 'undefined' && total > -1) {
      if (!!props.inSearch) {
        return (
          <div className="empty">
            <img src={require('../../assets/no-video.png')} />
            <p style={{ color: h2Color }}>{intl.get('Not found any video')}</p>
          </div>
        );
      } else {
        return (
          <div className="empty">
            <img src={require('../../assets/no-video.png')} />
            <p style={{ color: h2Color }}>{intl.get('No hot video')}</p>
          </div>
        );
      }
    }

    return null;
  };
  console.log(`livecut search`, videoStore.livecut_search);
  const renderedList = list && list.length
    ? list.map(renderItem).filter(Boolean)
    : [];
  const usePortraitMasonry =
    mode == '1' &&
    list &&
    typeof list.some === 'function' &&
    list.some((item: IMedium) => isPortraitItem(item));

  return (
    <div
      className={classNames('livecut', `mode${mode}`, {
        'has-portrait-layout': usePortraitMasonry
      })}
    >
      {!!inSearch && videoStore.livecut_search[cid]?.total == 0
        ? renderEmpty()
        : renderedList.length
        ? usePortraitMasonry
          ? <Masonry columnsCount={2} gutter="14px">{renderedList}</Masonry>
          : renderedList
        : renderEmpty()}
    </div>
  );
};

export default inject('rootStore')(observer(Index));
